/**
 * Edit Lead Profile
 */

import React, { useEffect, useState } from "react";
import { Box, Stepper, Step, StepButton, StepLabel } from "@mui/material";
import {
  ArrowBackSharp as IconBack,
  Edit as IconEdit,
  CheckCircle as IconVerify,
  Person as IconAssign,
  Store as IconStoreVisit,
  Assignment as IconDocVerify,
  Forum as IconApprove,
  Verified as IconQualified,
  HowToReg as IconConverted,
  LocalPrintshop as IconPrint,
  AccessTimeFilled as IconPreVerify,
  Gavel as IconLegalDoc,
  Headset as IconInterview,
  Quiz as IconQuestions,
  Scale,
} from "@mui/icons-material";

import NewLeadProfile from "../NewLeadProfile";
import StoreVisit from "../StoreVisit";
import DocVerification from "../DocVerification";
import LeadApprovals from "../LeadApprovals";
import Qualified from "../Qualified";
import Converted from "../Converted";
import Verified from "../Verified";
import AssignedInfo from "../AssignedInfo";
import PreVerification from "../PreVerification";
import LegalDocuments from "../LegalDocuments";
import InterviewProcess from "../InterviewProcess";
import InterviewQuestions from "../InterviewQuestions";

import { CRM_LEAD_STATUS, DEFAULTS } from "common/config";
import styled from "@emotion/styled";
import { COLORS } from "common/colors";

import { CRM_APIs } from "apihandlers/crm";

interface defaultProps {
  selectedRow;
}

const EditLeadProfile = (props: any) => {
  const { selectedRow, areas, onClose, states } = props;

  const [rows, setRows] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [remarksLoading, setRemarksLoading] = useState(true);

  useEffect(() => {
    getCrmRemarks();
  }, []);

  const getCrmRemarks = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        crmLeadId: selectedRow.id,
      };
      const res: any = await CRM_APIs.getCrmRemarks(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response;

        setRows(list);
        setRemarksLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const LeadStatus = [
    {
      id: CRM_LEAD_STATUS.NEW_LEAD,
      label: CRM_LEAD_STATUS.NEW_LEAD,
    },
    {
      id: CRM_LEAD_STATUS.PRE_VERIFICATION,
      label: CRM_LEAD_STATUS.PRE_VERIFICATION,
    },
    {
      id: CRM_LEAD_STATUS.VERIFIED,
      label: CRM_LEAD_STATUS.VERIFIED,
    },
    {
      id: CRM_LEAD_STATUS.ASSIGNED,
      label: CRM_LEAD_STATUS.ASSIGNED,
    },
    {
      id: CRM_LEAD_STATUS.FIELD_VISIT,
      label: CRM_LEAD_STATUS.FIELD_VISIT,
    },
    {
      id: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
      label: CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
    },
    {
      id: CRM_LEAD_STATUS.INTERVIEW_PROCESS,
      label: CRM_LEAD_STATUS.INTERVIEW_PROCESS,
    },
    {
      id: CRM_LEAD_STATUS.INTERVIEW_QUESTIONS,
      label: CRM_LEAD_STATUS.INTERVIEW_QUESTIONS,
    },
    {
      id: CRM_LEAD_STATUS.QUALIFIED,
      label: CRM_LEAD_STATUS.QUALIFIED,
    },
    {
      id: CRM_LEAD_STATUS.APPROVALS,
      label: CRM_LEAD_STATUS.APPROVALS,
    },
    {
      id: CRM_LEAD_STATUS.LEGAL_DOCUMENTS,
      label: CRM_LEAD_STATUS.LEGAL_DOCUMENTS,
    },
    {
      id: CRM_LEAD_STATUS.CONVERTED,
      label: CRM_LEAD_STATUS.CONVERTED,
    },
  ];
  const companyDetails = selectedRow.companyDetails
    ? JSON.parse(selectedRow.companyDetails)
    : {};
  const currentDetails = selectedRow.currentDetails
    ? JSON.parse(selectedRow.currentDetails)
    : {};
  const personalDetails = selectedRow.personalDetails
    ? JSON.parse(selectedRow.personalDetails)
    : {};
  const partnerDetails = selectedRow.partnerDetails
    ? JSON.parse(selectedRow.partnerDetails)
    : {};
  const storageDetails = selectedRow.storageDetails
    ? JSON.parse(selectedRow.storageDetails)
    : {};
  const familyData = selectedRow.familyDetails
    ? JSON.parse(selectedRow.familyDetails)
    : {};
  const vehicleDetails = selectedRow.vehicleDetails
    ? JSON.parse(selectedRow.vehicleDetails)
    : {};
  const interviewDetails = selectedRow.interviewDetails
    ? JSON.parse(selectedRow.interviewDetails)
    : {};

  let steps = [
    CRM_LEAD_STATUS.NEW_LEAD,
    CRM_LEAD_STATUS.PRE_VERIFICATION,
    CRM_LEAD_STATUS.VERIFIED,
    CRM_LEAD_STATUS.ASSIGNED,
    CRM_LEAD_STATUS.FIELD_VISIT,
    CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
    CRM_LEAD_STATUS.INTERVIEW_PROCESS,
    CRM_LEAD_STATUS.QUALIFIED,
    CRM_LEAD_STATUS.APPROVALS,
    CRM_LEAD_STATUS.LEGAL_DOCUMENTS,
    CRM_LEAD_STATUS.CONVERTED,
  ];
  let icons = [
    <IconPreVerify />,
    <IconPreVerify />,
    <IconVerify />,
    <IconAssign />,
    <IconStoreVisit />,
    <IconDocVerify />,
    <IconInterview />,
    <IconQualified />,
    <IconApprove />,
    <IconLegalDoc />,
    <IconConverted />,
  ];
  if (
    interviewDetails.interviewProcess === "Interview Schedule" ||
    interviewDetails.interviewProcess === "Interview Reschedule"
  ) {
    steps = [
      CRM_LEAD_STATUS.NEW_LEAD,
      CRM_LEAD_STATUS.PRE_VERIFICATION,
      CRM_LEAD_STATUS.VERIFIED,
      CRM_LEAD_STATUS.ASSIGNED,
      CRM_LEAD_STATUS.FIELD_VISIT,
      CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
      CRM_LEAD_STATUS.INTERVIEW_PROCESS,
      CRM_LEAD_STATUS.INTERVIEW_QUESTIONS,
      CRM_LEAD_STATUS.QUALIFIED,
      CRM_LEAD_STATUS.APPROVALS,
      CRM_LEAD_STATUS.LEGAL_DOCUMENTS,
      CRM_LEAD_STATUS.CONVERTED,
    ];

    icons = [
      <IconPreVerify />,
      <IconPreVerify />,
      <IconVerify />,
      <IconAssign />,
      <IconStoreVisit />,
      <IconDocVerify />,
      <IconInterview />,
      <IconQuestions />,
      <IconQualified />,
      <IconApprove />,
      <IconLegalDoc />,
      <IconConverted />,
    ];
  }

  let nextStep = 0;
  // if (selectedRow.crmLeadStatus === CRM_LEAD_STATUS.NEW_LEAD) {
  //   steps = [CRM_LEAD_STATUS.NEW_LEAD, CRM_LEAD_STATUS.PRE_VERIFICATION];
  //   nextStep = steps.indexOf(selectedRow.crmLeadStatus) + 1;
  // } else {
  nextStep = steps.indexOf(selectedRow.crmLeadStatus) + 1;
  if (nextStep >= steps.length) {
    nextStep = steps.length - 1;
  }
  // }

  const [activeStep, setActiveStep] = useState(nextStep);
  const [completed, setCompleted] = useState<{ [k: number]: boolean }>({});
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step: number) => () => {
    // setTabs("TAB " + { step });

    if (step <= steps.indexOf(selectedRow.crmLeadStatus)) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }

    setActiveStep(step);

    console.log(
      "index  clicked ",

      nextStep
    );
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  console.log("areas", areas);
  console.log("edit: ", activeStep, nextStep, interviewDetails);
  console.log("selected row", selectedRow);
  console.log("Rowss Crm", rows);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stepper
          nonLinear
          activeStep={activeStep}
          alternativeLabel
          sx={{
            padding: 1,

            "& .MuiButtonBase-root": {
              height: "8px",
              marginTop: "2px",
              marginBottom: "5px",
            },
            "& .MuiStep-root": {
              "& .MuiStepConnector-root": {
                "$ .MuiStepConnector-line": {
                  borderColor: COLORS.PRIMARY,
                },
              },
            },
          }}
        >
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index <= steps.indexOf(selectedRow.crmLeadStatus)}
              classes={{
                root:
                  index <= steps.indexOf(selectedRow.crmLeadStatus) &&
                  "activeStep",
              }}
            >
              {index <= steps.indexOf(selectedRow.crmLeadStatus) + 1 ? (
                <StepButton
                  icon={icons[index]}
                  color="inherit"
                  onClick={handleStep(index)}
                  className={
                    activeStep === index ? "stepperActiveBtn" : "stepperBtn"
                  }
                  sx={{
                    color: activeStep === index ? "#05385f" : "#2297f3",
                  }}
                >
                  <StepLabel
                    sx={{
                      fontWeight: activeStep === index && "900",
                      width: activeStep === index ? "75%" : "99%",
                    }}
                  >
                    {label}
                  </StepLabel>
                </StepButton>
              ) : (
                <StepLabel
                  icon={icons[index]}
                  sx={{
                    color: "#bdbdbd ",
                    width: "100%",
                  }}
                >
                  {label}
                </StepLabel>
              )}
            </Step>
          ))}
        </Stepper>

        <div style={{ marginTop: 20 }}>
          {activeStep === steps.indexOf(CRM_LEAD_STATUS.NEW_LEAD) && (
            <NewLeadProfile
              selectedRow={selectedRow}
              areas={areas}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}
          {activeStep === steps.indexOf(CRM_LEAD_STATUS.PRE_VERIFICATION) && (
            <PreVerification
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}
          {activeStep === steps.indexOf(CRM_LEAD_STATUS.VERIFIED) && (
            <Verified
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.ASSIGNED) && (
            <AssignedInfo
              selectedRow={selectedRow}
              onClose={onClose}
              areas={areas}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.FIELD_VISIT) && (
            <StoreVisit
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              allStates={states}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep ===
            steps.indexOf(CRM_LEAD_STATUS.DOCUMENT_VERIFICATION) && (
            <DocVerification
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.INTERVIEW_PROCESS) && (
            <InterviewProcess
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep ===
            steps.indexOf(CRM_LEAD_STATUS.INTERVIEW_QUESTIONS) && (
            <InterviewQuestions
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.APPROVALS) && (
            <LeadApprovals
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.QUALIFIED) && (
            <Qualified
              selectedRow={selectedRow}
              areas={areas}
              onClose={onClose}
              companyDetails={companyDetails}
              currentDetails={currentDetails}
              personalDetails={personalDetails}
              partnerDetails={partnerDetails}
              storageDetails={storageDetails}
              isButtonDisabled={isButtonDisabled}
              familyData={familyData}
              vehicleDetails={vehicleDetails}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.LEGAL_DOCUMENTS) && (
            <LegalDocuments
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}

          {activeStep === steps.indexOf(CRM_LEAD_STATUS.CONVERTED) && (
            <Converted
              selectedRow={selectedRow}
              onClose={onClose}
              isButtonDisabled={isButtonDisabled}
              remarksList={rows.remarks}
              getCrmRemarks={getCrmRemarks}
              remarksLoading={remarksLoading}
              setRemarksLoading={setRemarksLoading}
              leadStatus={LeadStatus}
              isApproved={rows.cancelOrApprove}
              activeStep={activeStep}
              nextStep={nextStep}
            />
          )}
        </div>
      </Box>
    </>
  );
};

export default EditLeadProfile;
